import { ElementRef } from '@angular/core';

export function scrollToFirstInvalidControl(el: ElementRef, wrapperSelector = ''): void {
    setTimeout(() => {
        const firstInvalidControl: HTMLElement
            = el.nativeElement.querySelector([
                `${wrapperSelector} mat-checkbox.ng-invalid`,
                `${wrapperSelector} mat-form-field .ng-invalid`,
                `${wrapperSelector} .invalid-anchor`
            ]) || el.nativeElement.querySelector(`${wrapperSelector} .ng-invalid`)
        ;

        if (firstInvalidControl) {
            firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, 10);
}
